import { render, staticRenderFns } from "./relocate.vue?vue&type=template&id=a7aec1b8"
import script from "./relocate.vue?vue&type=script&lang=js"
export * from "./relocate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports